module.exports = __webpack_public_path__ + "img/kronenansatz.602c04c3.svg";